<div class="estimated-costs-panel">
  <h5>Estimated TNC and Non-TNC Costs by Fiscal Year (FY) <span class="text-muted">(USD)</span>
</h5>

@if (fiscalYears.length) {

  <div class="results-grid" [ngClass]="{'stubby': fiscalYears.length <= 8}">
    <div class="results-header">
      <div>Fiscal Year (FY)</div>
      <div>
        Estimated TNC Costs<app-help-selector [selector]="1148"></app-help-selector>
      </div>
      <div>
        Estimated Non-TNC Costs<app-help-selector [selector]="1149"></app-help-selector>
      </div>
    </div>

    <div class="results-body">
      @for (year of fiscalYears; track year) {
        <div class="result-row">
          <div>
            FY{{year}}
          </div>
          <div>
            {{getEstimatedTncCosts(year) | currency: "USD": "symbol": "1.0-0"}}
          </div>
          <div>
            {{getEstimatedNonTncCosts(year) | currency: "USD": "symbol": "1.0-0"}}
          </div>
        </div>
      }

    </div>

    <div class="results-footer">
      <div>Total</div>
      <div>
        {{getTotalEstimatedTncCosts() | currency: "USD": "symbol": "1.0-0"}}
      </div>
      <div style="border-right: unset;">
        {{getTotalEstimatedNonTncCosts() | currency: "USD": "symbol": "1.0-0"}}
      </div>
    </div>

  </div>
}
@else {
<div>There is no information to display</div>
}

</div>
